import React from 'react'
import ReactDOM from 'react-dom'
import { createInstance } from '@module-federation/enhanced/runtime'
import getConfig from 'next/config'

// Global flag to prevent multiple initializations across component instances
let globalInitialized = false

// Module Federation instance
let mfInstance: ReturnType<typeof createInstance> | null = null

// Export getter function to access the instance
export function getMfInstance() {
  return mfInstance
}

// Initialize Module Federation immediately when module loads (client-side only)
if (typeof window !== 'undefined' && !globalInitialized) {
  const { publicRuntimeConfig } = getConfig() || {}
  const mfeUrl = publicRuntimeConfig?.NEXT_PUBLIC_KGE_MFE_ENTRY_POINT

  if (!mfeUrl) {
    console.error('NEXT_PUBLIC_KGE_MFE_ENTRY_POINT is not set')
  } else {
    try {
      // Initialize Module Federation
      mfInstance = createInstance({
        name: 'kge_mfe',
        remotes: [
          {
            name: 'koodoGlobalElementsMfe',
            entry: mfeUrl,
          },
        ],
        shared: {
          react: {
            version: '18.2.0',
            lib: () => React,
            shareConfig: {
              singleton: true,
              requiredVersion: '^18.2.0',
              eager: false,
            },
          },
          'react-dom': {
            version: '18.2.0',
            lib: () => ReactDOM,
            shareConfig: {
              singleton: true,
              requiredVersion: '^18.2.0',
              eager: false,
            },
          },
        },
      })

      // Preload the remote module in the background for better performance
      // This starts loading the module resources without blocking
      mfInstance
        .preloadRemote([
          {
            nameOrAlias: 'koodoGlobalElementsMfe',
            resourceCategory: 'all', // Preload both sync and async resources
          },
        ])
        .catch((error) => {
          console.warn('Failed to preload Module Federation remote:', error)
        })

      globalInitialized = true
    } catch (error) {
      console.error('Failed to initialize Module Federation:', error)
    }
  }
}
